import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  supports: [],
  isLoading: true,
  isViewModalOpen: false,
  isDeleteModalOpen: false,
  viewSingleSupport: {},
};

export const fetchSupports = createAsyncThunk("support/fetchSupports", () => {
  return axios
    .get("https://62de2ff379b9f8c30ab47809.mockapi.io/supports")
    .then((response) => response.data);
});

const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {
    viewSupport: (state, action) => {
      state.isViewModalOpen = true;
      state.viewSingleSupport = action.payload;
    },
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSingleSupport = action.payload;
    },
    closeModal: (state) => {
      state.isViewModalOpen = false;
      state.isDeleteModalOpen = false;
      state.viewSingleSupport = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSupports.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSupports.fulfilled, (state, action) => {
      state.isLoading = false;
      state.supports = action.payload;
      state.error = "";
    });
    builder.addCase(fetchSupports.rejected, (state, action) => {
      state.isLoading = false;
      state.supports = [];
      state.error = action.error.message;
    });
  },
});

export const { viewSupport, openDeleteModal, closeModal } =
  supportSlice.actions;
export default supportSlice.reducer;
